import { List, ListItem, ListItemButton, Typography } from '@mui/material';
import LabeledList from '~/components/LabeledList';

type CustomizationSelectionProps = {
    selectedCustomization?: string;
    onSelectedCustomizationChanged: (customizationName?: string) => void;
    customizations?: {
        name: string;
        label: string;
    }[];
};

export default function CustomizationSelection({
    customizations,
    selectedCustomization,
    onSelectedCustomizationChanged,
}: CustomizationSelectionProps) {
    return (
        <LabeledList label="Customizations">
            {customizations ? (
                <List dense disablePadding data-testid="customization-list">
                    <ListItem disablePadding>
                        <ListItemButton
                            data-testid="customization-default"
                            selected={!selectedCustomization}
                            onClick={() => onSelectedCustomizationChanged()}
                        >
                            <Typography fontSize={12}>default</Typography>
                        </ListItemButton>
                    </ListItem>

                    {customizations.map((customization) => {
                        const parsedName =
                            customization.name.split('.').pop() || '';
                        return (
                            <ListItem key={customization.name} disablePadding>
                                <ListItemButton
                                    data-testid={`customization-${parsedName}`}
                                    selected={
                                        selectedCustomization === parsedName
                                    }
                                    onClick={() =>
                                        onSelectedCustomizationChanged(
                                            parsedName
                                        )
                                    }
                                >
                                    <Typography fontSize={12}>
                                        {parsedName}
                                    </Typography>
                                </ListItemButton>
                            </ListItem>
                        );
                    })}
                </List>
            ) : (
                <Typography fontSize={10} p={2} textAlign="center">
                    Choose a model to see available customizations
                </Typography>
            )}
        </LabeledList>
    );
}
